export const OptionsNumerous = (length, start = 0) =>
  Array.from({ length: length }, (_, i) => ({
    value: start + i,
    label: String(start + i),
  }));
